// The six module icons, paths taken verbatim from the "Mission Control
// Glass" design page's nav so the built app matches the reference exactly.

type IconProps = { size?: number };

function Icon({ size = 20, children }: { size?: number; children: React.ReactNode }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round">{children}</svg>
  );
}

export function IconSessions({ size }: IconProps) {
  return <Icon size={size}><path d="M4 12l8-8 8 8M6 10v10h12V10" /></Icon>;
}

export function IconBoard({ size }: IconProps) {
  return (
    <Icon size={size}>
      <rect x="4" y="4" width="16" height="16" rx="2" /><path d="M4 10h16M10 10v10" />
    </Icon>
  );
}

export function IconMoney({ size }: IconProps) {
  return (
    <Icon size={size}>
      <rect x="3" y="7" width="18" height="12" rx="2" /><path d="M3 11h18" />
    </Icon>
  );
}

export function IconBody({ size }: IconProps) {
  return (
    <Icon size={size}>
      <circle cx="12" cy="5" r="2" /><path d="M12 7v7M8 21l4-7 4 7M7 11l5-2 5 2" />
    </Icon>
  );
}

export function IconJournal({ size }: IconProps) {
  return <Icon size={size}><path d="M6 4h9l4 4v12H6zM9 12h6M9 16h6" /></Icon>;
}

export function IconCalendar({ size }: IconProps) {
  return (
    <Icon size={size}>
      <rect x="4" y="5" width="16" height="15" rx="2" /><path d="M4 10h16M8 3v4M16 3v4" />
    </Icon>
  );
}

export function IconSearch({ size }: IconProps) {
  return <Icon size={size}><circle cx="11" cy="11" r="6" /><path d="M16 16l4 4" /></Icon>;
}
